import React from 'react'
import clsx from 'clsx'

export const Label = ({ children, className, small, ...props }) => {
  return <div className={clsx(className, small ? 'text-lg md:text-xl' : 'text-xl md:text-2xl', 'font-semibold')} {...props} >{children}</div>
}

export default Label
